import { useEffect } from 'react';
import 'styles/VerifictionForm.scss';

const VerficationForm = ({ verifyPromo, error, setVoucherCode }) => {
    function formatPromoCode(inputField) {
        const maxLength = 12;
        const oldValue = inputField.value;
        let newValue = oldValue.replace(/-/g, '');
        newValue = newValue.substring(0, maxLength);
        const newLength = newValue.length;

        if (newLength > 0) {
            let formattedValue = '';
            for (let i = 0; i < newLength; i++) {
                if (i > 0 && i % 4 === 0) {
                    formattedValue += '-';
                }
                formattedValue += newValue.charAt(i);
            }
            inputField.value = formattedValue;
            setVoucherCode(formattedValue);
        } else {
            inputField.value = '';
        }
    }

    function handleInput() {
        const inputField = document.querySelector('.text-field input');
        if (inputField != null) {
            formatPromoCode(inputField);
        }
    }
    
    useEffect(() => {
        const inputField = document.querySelector('.text-field input');
        if (inputField != null) {
            formatPromoCode(inputField);
            inputField.addEventListener('input', handleInput);
        }
    }, []);
    return (
    <div id="verification-form">
        <div className="heading">
            Verify voucher code
        </div>
        <div className="subheading">
            Enter the voucher code presented by the customer to avail free service
        </div>
        <div className="text-field" >
            <input type="text" placeholder='xxxx-xxxx-xxxx' />
        </div>
        <div className="verify-button" onClick={verifyPromo}>
            Verify
        </div>
        <div className="error-message">
            {
                error
                    ?
                    <div className="error-message">
                        {error}
                    </div>
                    :
                    null
            }
        </div>
    </div>
    );
}

export default VerficationForm;